import OutlinedButton from "features/shared/components/buttons/OutlinedButton.styled";
import styled from "styled-components";

const ButtonGroup = styled.div`
  display: flex;
  gap: 16px;

  ${OutlinedButton} {
    position: initial;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    flex-direction: column;
  }
`;

export default ButtonGroup;
